import { render, staticRenderFns } from "./ListInfo.vue?vue&type=template&id=864b90b4&"
import script from "./ListInfo.vue?vue&type=script&lang=js&"
export * from "./ListInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListInfo.vue"
export default component.exports